import { Avatar, AvatarFallback, AvatarImage } from 'components/ui/avatar'
import * as React from 'react'

interface AvatarProps {
    src?: string
    fallback: string
    className?: string
}

const CAvatar = ({ src, fallback, className }: AvatarProps) => {
    return (
        <Avatar className={className}>
            <AvatarImage src={src} />
            <AvatarFallback>{fallback}</AvatarFallback>
        </Avatar>
    )
}

export default CAvatar
